const TEST_INTERVAL = 750 // 每次做题有 750 毫秒的间隔

export function getResultText(type, score) {
  if (type === 1) {
    // 阅读
    if (score <= 1000)
      return '欢迎来到英语新手村~现在你的词汇量水平还在入门级哟，不过我相信你潜力满满，快去制定计划和我一起逆袭吧！'
    else if (score <= 3800)
      return '你能用英语进行日常沟通喔~美国小朋友能说的，你也行的。加油继续背单词，向着更加地道的表达冲刺吧！'
    else if (score <= 6500)
      return '恭喜你，你的词汇量已经向全球非英语母语人群的平均水平线看齐啦！继续加油，早日飞跃平均线！'
    else if (score <= 9500)
      return '我猜，你的英语水平听歌能秒懂歌词，看美剧不需要字幕吧！这差不多是美国本土中学生的英语水平喔。'
    else if (score <= 12000)
      return '哇，听说只有不到20%的英语学习者有这个词汇量耶~你和外国人的英语水平只有一步之遥，难道是个隐藏学霸？'
    return '我酸了，这么高的词汇量~！！！实在硬核，等我回过神再答复你，谢谢~'
  } else {
    // 听力
    if (score <= 1000)
      return '欢迎来到英语新手村~现在你的词汇量水平还在入门级哟，不过我相信你潜力满满，快去制定计划和我一起逆袭吧！'
    else if (score <= 3500)
      return '你能用英语进行日常沟通喔~美国小朋友能说的，你也行的。加油继续背单词，向着更加地道的表达冲刺吧！'
    else if (score <= 5500)
      return '恭喜你，你的词汇量已经向全球非英语母语人群的平均水平线看齐啦！继续加油，早日飞跃平均线！'
    else if (score <= 7500)
      return '我猜，你的英语水平听歌能秒懂歌词，看美剧不需要字幕吧！这差不多是美国本土中学生的英语水平喔。'
    else if (score <= 9500)
      return '哇，听说只有不到20%的英语学习者有这个词汇量耶~你和外国人的英语水平只有一步之遥，难道是个隐藏学霸？'
    return '我酸了，这么高的词汇量~！！！实在硬核，等我回过神再答复你，谢谢~'
  }
}

export function shuffle(arr) {
  arr.sort(() => Math.random() - 0.5)
  return arr
}

export function waitToNext() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve('sleeped')
    }, TEST_INTERVAL)
  })
}

export function changeScoreArray(score) {
  const arr = Array.from(score + '')
  while (arr.length < 4) {
    arr.unshift('0')
  }
  return arr
}

export const isHarmony = /bcz_app_harmony/.test(navigator.userAgent)
export const isVLD = /bcz_vld_([a-zA-Z]+)_?(ireading)?\/(\d+)/i.test(
  navigator.userAgent
);
